// =============================================================================
// INDEX.JS - Point d'entrée de l'application React
// =============================================================================
// Ce fichier est le premier à être exécuté par React.
// Il fait le lien entre React et le DOM HTML (la page web).

// =============================================================================
// IMPORTS
// =============================================================================

// React : la bibliothèque principale pour créer des composants
import React from 'react';

// ReactDOM : permet de "monter" React dans une page HTML
// 'react-dom/client' est la version moderne (React 18+)
import ReactDOM from 'react-dom/client';

// Styles CSS globaux pour toute l'application
import './index.css';

// Notre composant principal App
import App from './App';

// =============================================================================
// CRÉATION DE LA RACINE REACT
// =============================================================================
// createRoot() crée un point d'ancrage pour React dans le DOM
// document.getElementById('root') récupère l'élément <div id="root"> du fichier index.html
// C'est dans cette div que toute notre application React sera rendue

const root = ReactDOM.createRoot(document.getElementById('root'));

// =============================================================================
// RENDU DE L'APPLICATION
// =============================================================================
// root.render() affiche notre application dans le navigateur

root.render(
  // React.StrictMode est un outil de développement qui :
  // - Détecte les problèmes potentiels dans l'application
  // - Active des vérifications et avertissements supplémentaires
  // - N'affecte pas la version de production (build)
  // Note : en mode strict, les effets (useEffect) sont exécutés 2 fois
  // pour détecter les problèmes de nettoyage
  <React.StrictMode>
    {/* App est notre composant racine qui contient toute l'application */}
    <App />
  </React.StrictMode>
);

// =============================================================================
// MESURE DE PERFORMANCE (optionnel, désactivé par défaut)
// =============================================================================
// reportWebVitals permet de mesurer les performances de l'application
// Utile pour analyser le temps de chargement, l'interactivité, etc.
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);
